export default "__VITE_ASSET__C5nmP2BE__"